import React, { useState } from 'react';
import PropTypes from 'prop-types';
import searchIcon from 'assets/images/icons/search.svg';
import TextField from 'components/form-components/TextField';
import ArchivedTaskActions from './ArchivedTaskActions';

const ArchivedTaskListHeader = ({ handleDebouncedFilter, selectedRows, actionsCallBack }) => {
  const [searchText, setSearchText] = useState('');

  return (
    <div className='my-3 d-flex gap-2 flex-wrap justify-content-between align-items-end'>
      <div className='d-flex gap-3'>
        <TextField
          value={searchText}
          name='search'
          handleChange={(_, value) => setSearchText(value)}
          placeholder={'field_search'}
          icon={searchIcon}
          debounceFunc={handleDebouncedFilter}
          shrink
        />

        <ArchivedTaskActions
          ids={selectedRows}
          isActionButton={false}
          actionsCallBack={actionsCallBack}
        />
      </div>
    </div>
  );
};

ArchivedTaskListHeader.propTypes = {
  handleDebouncedFilter: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func,
};

export default ArchivedTaskListHeader;
